var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHarddrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2766 18.0331C9.47486 19.1158 7.97792 19.32 6.93308 18.4892C5.88824 17.6584 5.69116 16.1072 6.4929 15.0245C6.99476 14.3467 8.63352 13.7242 9.78918 13.3533C10.4022 13.1566 11.0056 13.6149 10.9827 14.2584C10.9381 15.5125 10.7842 17.3476 10.2766 18.0331Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4681 13.9449C13.3469 13.7342 14 12.9434 14 12C14 10.8954 13.1046 10 12 10C10.9605 10 10.1062 10.793 10.0092 11.8071C11.2416 11.7694 12.3279 12.6883 12.4681 13.9449Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2ZM17 6C17.5523 6 18 5.55228 18 5C18 4.44772 17.5523 4 17 4C16.4477 4 16 4.44772 16 5C16 5.55228 16.4477 6 17 6ZM18 19C18 18.4477 17.5523 18 17 18C16.4477 18 16 18.4477 16 19C16 19.5523 16.4477 20 17 20C17.5523 20 18 19.5523 18 19ZM7 6C7.55228 6 8 5.55228 8 5C8 4.44772 7.55228 4 7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 12.4581 6.05134 12.9043 6.14859 13.3329C5.86006 13.5305 5.5383 13.793 5.28741 14.1319C4.01202 15.8542 4.3123 18.3217 5.99951 19.6633C7.71932 21.0308 10.1835 20.6794 11.4821 18.9257C11.6995 18.632 11.8483 18.3015 11.9542 17.9998C11.9695 17.9999 11.9847 18 12 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarddrive);
export default __webpack_public_path__ + "static/media/harddrive.5169bc33745a0877d1c9c40eaa18c460.svg";
export { ForwardRef as ReactComponent };